import { render } from "./OverviewNav.vue?vue&type=template&id=36b895e5&scoped=true"
import script from "./OverviewNav.vue?vue&type=script&lang=js"
export * from "./OverviewNav.vue?vue&type=script&lang=js"

import "./OverviewNav.vue?vue&type=style&index=0&id=36b895e5&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b895e5"]])

export default __exports__